import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.SUPPLIER_NOTE,
    method: 'POST',
    data: content,
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.SUPPLIER_NOTE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.SUPPLIER_NOTE}/${id}`,
    method: 'DELETE',
  });

const getByOwner = (supplierId, page) =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.SUPPLIER_NOTE}`,
    method: 'GET',
    params: {
      page: page || 1,
      pageSize: 5,
      filter: [
        {
          type: 'eq',
          field: 'supplier',
          value: supplierId,
        },
      ],
    },
    paramsSerializer: params => qs.stringify(params),
  });

const NoteService = {
  getByOwner,
  create,
  update,
  remove,
};

export default NoteService;
